import { map } from 'lodash'

// TODO: Add all the flags we
const TagLanguages = {
    AA: '🏴󠁥󠁴󠁡󠁦󠁿  Afar',
    AB: 'Abkhazian',
    AF: 'Afrikaans',
    AKK: 'Akan',
    AM: 'Amharic',
    AR: '🇸🇦  Arabic',
    ARC: 'Aramaic',
    AS: 'Assamese',
    ASE: 'American Sign Language',
    AY: 'Aymara',
    AZ: 'Azerbaijani',
    BA: 'Bashkir',
    BE: 'Belarusian',
    BG: 'Bulgarian',
    BH: 'Bihari',
    BI: 'Bislama',
    BN: '🇧🇩  Bengali',
    BO: 'Tibetan',
    BR: 'Breton',
    BRX: 'Bodo',
    BS: 'Bosnian',
    CA: 'Catalan',
    CHO: 'Choctaw',
    CHR: 'Cherokee',
    CO: 'Corsican',
    COP: 'Coptic',
    CR: 'Cree',
    CS: '🇨🇿  Czech',
    CY: 'Welsh',
    DA: '🇩🇰  Danish',
    'DE-AT': '🇩🇪  German (Austria)',
    'DE-CH': '🇩🇪  German (Switzerland)',
    'DE-DE': '🇩🇪  German (Germany)',
    DE: '🇩🇪  German',
    DOI: 'Dogri',
    DZ: 'Dzongkha',
    EL: 'Greek',
    'EN-CA': '🇨🇦  English [Canada]',
    'EN-GB': '🇬🇧  English [United Kingdom]',
    'EN-IE': '🇮🇪  English [Ireland]',
    'EN-IN': '🇺🇸  English [India]',
    'EN-US': '🇺🇸  English',
    EN: '🇬🇧  English',
    EO: 'Esperanto',
    'ES-419': '🇪🇸  Spanish [Latin America]',
    'ES-ES': '🇪🇸  Spanish [Spain]',
    'ES-MX': '🇲🇽  Spanish [Mexico]',
    'ES-US': '🇪🇸  Spanish [United States]',
    ES: '🇪🇸  Spanish [Spain]',
    ET: 'Estonian',
    EU: 'Basque',
    'FA-AF': 'Persian',
    'FA-IR': 'Persian',
    FA: '🇮🇷  Farsi',
    FF: 'Fulah',
    FI: '🇫🇮  Finnish',
    FIL: 'Filipino',
    FJ: 'Fijian',
    FO: 'Faroese',
    'FR-BE': '🇫🇷  French [Belgium]',
    'FR-CA': '🇫🇷  French [Canada]',
    'FR-CH': '🇫🇷  French [Switzerland]',
    'FR-FR': '🇫🇷  French',
    FR: '🇫🇷  French',
    FY: 'Western Frisian',
    GA: 'Irish',
    GD: 'Gaelic [Scottish]',
    GL: 'Galician',
    GN: 'Guarani',
    GU: 'Gujarati',
    HA: 'Hausa',
    'HAK-TW': 'Hakka Chinese (Taiwan)',
    HAK: 'Hakka Chinese',
    HAW: 'Hawaiian',
    'HI-LATN': '🇮🇳 Hindi (Latin)',
    HI: '🇮🇳  Hindi',
    HO: 'Hiri Motu',
    HR: 'Croatian',
    HT: 'Haitian',
    HU: '🇭🇺  Hungarian',
    HY: 'Armenian',
    IA: 'Interlingua',
    ID: '🇮🇩  Indonesian',
    IE: 'Interlingue [Occidental]',
    IG: 'Igbo',
    IK: 'Inupiaq',
    IS: '🇮🇸 Icelandic',
    IT: '🇮🇹  Italian',
    IU: 'Inuktitut',
    IW: '🇮🇱  Hebrew',
    JA: '🇯🇵  Japanese',
    JV: 'Javanese',
    KA: 'Georgian',
    KK: 'Kazakh',
    KL: 'Greenlandic',
    KM: 'Central Khmer',
    KN: 'Kannada',
    KO: '🇰🇷  Korean',
    KOK: 'Konkani',
    KS: 'Kashmiri',
    KU: 'Kurdish',
    KY: 'Kirghiz',
    LA: 'Latin',
    LAD: 'Ladino',
    LB: 'Luxembourgish',
    LN: 'Lingala',
    LO: 'Lao',
    LT: 'Lithuanian',
    LUS: 'Lushai',
    LV: 'Latvian',
    MAI: 'Maithili',
    MAS: 'Masai',
    MG: 'Malagasy',
    MI: 'Maori',
    MK: 'Macedonian',
    ML: 'Malayalam',
    'MN-MONG': '🇲🇳 Mongolian (Mongolian)',
    MN: '🇲🇳  Mongolia',
    MNI: 'Manipuri',
    MO: 'Romanian (Moldova)',
    MR: 'Marathi',
    MS: '🇲🇾  Malay',
    MT: 'Maltese',
    MXP: 'Mixe',
    MY: 'Burmese',
    NA: 'Nauru',
    'NAN-TW': 'Min Nan Chinese (Taiwan)',
    NAN: 'Min Nan Chinese',
    NE: 'Nepali',
    'NL-BE': '🇳🇱  Dutch [Belgium]',
    'NL-NL': '🇳🇱  Dutch',
    NL: '🇳🇱  Dutch',
    NO: '🇳🇴  Norwegian',
    NV: 'Navajo',
    OC: 'Occitan',
    OM: 'Oromo',
    OR: 'Oriya',
    PA: 'Punjabi',
    PAP: 'Papiamento',
    PL: '🇵🇱  Polish',
    PS: 'Pushto',
    'PT-BR': 'Portuguese (Brazil)',
    'PT-PT': 'Portuguese (Portugal)',
    PT: '🇵🇹  Portuguese',
    QU: 'Quechua',
    RM: 'Romansh',
    RN: 'Rundi',
    RO: '🇷🇴  Romanian',
    'RU-LATN': '🇷🇺  Russian',
    RU: '🇷🇺  Russian',
    RW: 'Kinyarwanda',
    SA: 'Sanskrit',
    SAT: 'Santali',
    SC: 'Sardinian',
    SCN: 'Sicilian',
    SD: 'Sindhi',
    SDP: 'Sherdukpen',
    SG: 'Sango',
    SH: 'Serbo-Croatian',
    SI: 'Sinhalese',
    SK: 'Slovak',
    SL: 'Slovenian',
    SM: 'Samoan',
    SN: 'Shona',
    SO: 'Somali',
    SQ: 'Albanian',
    'SR-CYRL': 'Serbian (Cyrillic)',
    'SR-LATN': 'Serbian (Latin)',
    SR: 'Serbian',
    SS: 'Swati',
    ST: 'Sotho',
    SU: 'Sundanese',
    SV: '🇸🇪  Swedish',
    SW: 'Swahili',
    TA: 'Tamil',
    TE: 'Telugu',
    TG: 'Tajik',
    TH: '🇹🇭  Thai',
    TI: 'Tigrinya',
    TK: 'Turkmen',
    TL: '🇵🇭  Tagalog',
    TLH: 'Klingon',
    TN: 'Tswana',
    TO: 'Tonga',
    TPI: 'Tok Pisin',
    TR: '🇹🇷  Turkish',
    TS: 'Tsonga',
    TT: 'Tatar',
    TW: 'Twi',
    UG: 'Uyghur',
    UK: '🇺🇦  Ukranian',
    UR: 'Urdu',
    UZ: 'Uzbek',
    VE: 'Venda',
    VI: '🇻🇳  Vietnamese',
    VO: 'Volapük',
    VRO: 'Võro',
    WO: 'Wolof',
    XH: 'Xhosa',
    YI: 'Yiddish',
    YO: 'Yoruba',
    'YUE-HK': 'Cantonese (Hong Kong)',
    YUE: 'Cantonese',
    'ZH-CN': 'Chinese [PRC]',
    'ZH-HANS': '🇨🇳  Chinese (Simplified)',
    'ZH-HANT': '🇨🇳  Chinese (Traditional)',
    'ZH-HK': 'Chinese [Hong Kong]',
    'ZH-SG': 'Chinese [Singapore]',
    'ZH-TW': '🇹🇼  Chinese [Taiwan]',
    ZH: '🇨🇳  Chinese',
    ZU: 'Zulu',
}

export const TagLanguagesAlt = map(TagLanguages, (value, key) => {
    return { name: value, value: key }
})
